'use client';

import React from 'react';

const MatchMakerMaterialStockReconciliationListPage: React.FC = () => {
  return (
    <div className="px-6 py-6 md:px-14 flex flex-col items-center justify-center min-h-[60vh]">
      <h1 className="text-2xl font-bold mb-4">
        Match materials to reconcile stocks
      </h1>
      <div className="bg-white rounded-lg shadow p-8 flex flex-col items-center">
        <svg
          className="w-16 h-16 text-gray-300 mb-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 48 48"
        >
          <circle
            cx="24"
            cy="24"
            r="20"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M16 24h16M24 16v16"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <h2 className="text-xl font-semibold mb-2">Coming Soon</h2>
        <p className="text-gray-500 text-center">
          We're working hard to bring you this feature. Stay tuned!
        </p>
      </div>
    </div>
  );
};

export default MatchMakerMaterialStockReconciliationListPage;
